import { useWindowDimensions } from 'react-native';
export const useWindowWidth = () => {
    const { width } = useWindowDimensions();
    return width;
};
//# sourceMappingURL=useWindowWidth.js.map